import { TESTIMONIAL_GET_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getTestimonial = (data) => ({
    type: TESTIMONIAL_GET_LIST,
    payload: data
});
